import React from 'react';

function NavItem({ icon, label, active, onClick }) {
  return (
    <div onClick={onClick} className={`flex items-center gap-5 p-5 rounded-[25px] cursor-pointer transition-all duration-500 ${active ? 'bg-blue-600 text-white shadow-2xl translate-x-3 scale-105' : 'text-slate-500 hover:text-white hover:bg-slate-800/50'}`}>
      {React.cloneElement(icon, { size: 24, strokeWidth: 2.5 })}
      <span className="font-black text-sm tracking-tight">{label}</span>
    </div>
  );
}

export default NavItem;
